<div id="search-container" style="margin-left: 24px;">  
  <div class="search-box inner-addon right-addon">
    <fa-icon [icon]="faSearch"></fa-icon>
    <input id="search-text" aria-label="Search Text" class="search-text" autocomplete="off" placeholder="Type to search surveys and templates" (keyup)="search($event.target.value)" />    
  </div>
</div>
